import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable, of, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../auth-service/auth-service.service';
@Injectable({
  providedIn: 'root'
})
export class XevprmSubmissionService {

  public loading = new BehaviorSubject<boolean>(false);


  constructor(private httpClient: HttpClient,
    private authService: AuthService
  ) { }

  /**
   * See very good answer on how submit files
   * together with data with its content type
   * https://stackoverflow.com/questions/24535189/composing-multipart-form-data-with-a-different-content-type-on-each-parts-with-j
   */
  submit<ResultType>(message: any, attachments: any[]): Observable<any> {
    const formData = new FormData();
    this.loading.next(true);



    if (attachments && attachments.length > 0) {
      // Files
      for (let i = 0; i < attachments.length; i++) {
        if (attachments[i].file) {
          if (attachments[i]&&attachments[i].filename&&attachments[i].filename.lastIndexOf('.') === -1) {
            attachments[i].filename = attachments[i].filename + this.getAttachmentType(attachments[i].filetype);
          }
          formData.append("files", attachments[i].file[0], attachments[i].filename);
        }

      }
    }

    // Message sent as JSON
    formData.append("message", new Blob(
      [JSON.stringify(message)],
      { type: "application/json" }
    ));

    //Headers
    let headers = new HttpHeaders(
      {
        'Authorization': 'Bearer ' + this.authService.getAccessToken(),
        'AuthSession': this.authService.getSessionToken()
      }
    );

    //Post
    return this.httpClient.post(environment.apiUrl + "/api/xevprm/submit", formData, { headers: headers }).pipe(
      map((resp) => {
        const result = resp as [];
        this.loading.next(false);
        return result;
      }),
      catchError((error) => {
        this.loading.next(false);
        return throwError(() => error); //return ""; //tbc empty value?
      })
    );
  }


  getAttachmentType(code: number) {
    let type;
    switch (code) {
      case 1:
        type = ".PDF";
        break;
      case 2:
        type = ".DOC";
        break;
      case 3:
        type = ".DOCX";
        break;
      case 4:
        type = ".XLS";
        break;
      case 5:
        type = ".XLSX";
        break;
    }

    return type;
  }
}
